import Phaser from 'phaser';
import { InputState } from './InputState';

export class KeyboardInput {
  private k: {
    D: Phaser.Input.Keyboard.Key;
    W: Phaser.Input.Keyboard.Key;
    L: Phaser.Input.Keyboard.Key;
    R: Phaser.Input.Keyboard.Key;
    U: Phaser.Input.Keyboard.Key;
    DN: Phaser.Input.Keyboard.Key;
    Space: Phaser.Input.Keyboard.Key;
    Z: Phaser.Input.Keyboard.Key;
    X: Phaser.Input.Keyboard.Key;
    J: Phaser.Input.Keyboard.Key;
    A: Phaser.Input.Keyboard.Key;  // heal (Focus) — было C
    C: Phaser.Input.Keyboard.Key;  // dash — было Shift
    S: Phaser.Input.Keyboard.Key;  // spell — было V
  };

  constructor(scene: Phaser.Scene) {
    const kb = scene.input.keyboard!;
    const KC = Phaser.Input.Keyboard.KeyCodes;
    this.k = {
      D: kb.addKey(KC.D),
      W: kb.addKey(KC.W),
      L: kb.addKey(KC.LEFT),
      R: kb.addKey(KC.RIGHT),
      U: kb.addKey(KC.UP),
      DN: kb.addKey(KC.DOWN),
      Space: kb.addKey(KC.SPACE),
      Z: kb.addKey(KC.Z),
      X: kb.addKey(KC.X),
      J: kb.addKey(KC.J),
      A: kb.addKey(KC.A),
      C: kb.addKey(KC.C),
      S: kb.addKey(KC.S),
    };
  }

  update(state: InputState) {
    // A и S больше не движение — они переназначены на heal и spell.
    // Лево/низ только на стрелки. Право/верх — на стрелки и D/W (без конфликта).
    if (this.k.L.isDown) state.left = true;
    if (this.k.D.isDown || this.k.R.isDown) state.right = true;
    if (this.k.W.isDown || this.k.U.isDown) state.up = true;
    if (this.k.DN.isDown) state.down = true;
    if (this.k.Space.isDown || this.k.Z.isDown) state.jumpHeld = true;
    if (this.k.A.isDown) state.focusHeld = true;

    const J = Phaser.Input.Keyboard.JustDown;
    if (J(this.k.Space) || J(this.k.Z)) state.jumpPressed = true;
    if (J(this.k.X) || J(this.k.J)) state.attackPressed = true;
    if (J(this.k.C)) state.dashPressed = true;
    if (J(this.k.S)) state.spellPressed = true;
  }
}
